import { Link } from "@mui/material";

export function LearnMorePrivacyPolicyText() {
  return (
    <>
      To learn more about how we use location data, as well as your options to control your personal
      information, please review our{" "}
      <Link target="_blank" href="https://clipboardhealth.com/privacy-policy" rel="noreferrer">
        Privacy Policy
      </Link>
      .
    </>
  );
}
